const EmptyRouterView = () => import(/* webpackChunkName: "group-pose" */ '@/components/quickytools/empty-router-view')
const Pose = () => import(/* webpackChunkName: "group-pose" */ '@/components/poseEstimate/three-pose')
const DebugPose = () => import(/* webpackChunkName: "group-pose" */ '@/components/poseEstimate/debug-pose-estimation')

export default {
  path: '/pose-estimate',
  component: EmptyRouterView,

  children: [{
    path: 'three-pose',
    component: Pose
  }, {
    path: 'debug-pose',
    component: DebugPose
  }]
}
